var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaturkanon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.977,4.211H4.613a.8.8,0,1,1,0-1.593h7.364a.2.2,0,0,0,0-.4H4.613a1.2,1.2,0,0,0-1.2,1.195l0,8.761a1.2,1.2,0,0,0,1.194,1.2h7.368a.2.2,0,0,0,.2-.2V4.41A.2.2,0,0,0,11.977,4.211ZM9.749,10.046A.857.857,0,0,1,8.677,9.87l-.418.242V11.34a.1.1,0,0,1-.1.1H8.015a.1.1,0,0,1-.1-.1V10.112L7.5,9.87a.857.857,0,0,1-1.072.176A4.212,4.212,0,0,1,5.354,8.434a4.234,4.234,0,0,1,1.933.126.858.858,0,0,1,.384,1.016l.248.144V8.436A.859.859,0,0,1,7.231,7.6a4.218,4.218,0,0,1,.858-1.737A4.218,4.218,0,0,1,8.947,7.6a.859.859,0,0,1-.688.841V9.72l.248-.144A.859.859,0,0,1,8.891,8.56a4.234,4.234,0,0,1,1.933-.126A4.212,4.212,0,0,1,9.749,10.046Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturkanon);
export default __webpack_public_path__ + "static/media/NATURKANON.9680e86db652ded62542b7b8f60ff566.svg";
export { ForwardRef as ReactComponent };